// Morning Briefing — ONE item row: photo | model + PI | supplier | why | actions.
// The row is an 84px CSS grid with fixed tracks (see briefingRows.module.css) so every text sits on the same baseline
// in every row; the action slots are fixed too (Open · Tomorrow · Done), and Undo lands exactly where Done was.
import React from 'react';
import { canOpenNotification } from '../../../utils/entityRoutes';
import { getSnoozed } from './briefingStore';
import BriefingPhoto from './BriefingPhoto';
import { IcOpen, IcCheck, IcMoon } from './briefingIcons';
import cs from './briefing.module.css';
import styles from './briefingRows.module.css';

/** The colour family of a row (and of its section). */
export const toneOf = (i) => (i.group === 'late' ? (i.days >= 21 ? 'hot' : i.days >= 8 ? 'warm' : 'mild')
  : i.group === 'today' ? 'today' : i.group === 'attention' ? 'info' : i.group === 'mentions' ? 'reply' : i.group === 'soon' ? 'soon' : 'fyi');

function Acts({ item, handled, canOpen, onOpen, onDone, onSnooze, onUndo }) {
  const fyi = item.group === 'fyi';
  const open = canOpen
    ? <button type="button" className={`${styles.b} ${styles.bOpen}`} onClick={onOpen} data-test="briefing-open"><IcOpen />Open</button>
    : <span />;
  if (handled) {
    const later = !!getSnoozed()[item.id];
    return (
      <>
        {open}
        <span className={`${styles.st} ${later ? styles.stLater : styles.stOk}`}>{later ? <IcMoon /> : <IcCheck />}{later ? 'Tomorrow' : fyi ? 'Read' : 'Done'}</span>
        <button type="button" className={styles.undo} onClick={onUndo} data-test="briefing-undo">Undo</button>
      </>
    );
  }
  return (
    <>
      {open}
      {fyi ? <span /> : <button type="button" className={`${styles.b} ${styles.bLater}`} onClick={onSnooze} data-test="briefing-snooze"><IcMoon />Tomorrow</button>}
      <button type="button" className={`${styles.b} ${styles.bDone}`} onClick={onDone} data-test="briefing-done"><IcCheck />{fyi ? 'Got it' : 'Done'}</button>
    </>
  );
}

export function ItemRow({ item, handled, rank, photo, onOpen, onDone, onSnooze, onUndo, onZoom }) {
  const canOpen = canOpenNotification(item.n);
  const model = item.model || item.noun;
  return (
    <article className={`${styles.r} ${cs['t_' + toneOf(item)]}${handled ? ' ' + styles.isH : ''}`} data-test="briefing-item" data-group={item.group}>
      <div className={styles.pic}>
        {rank ? <span className={styles.rank} aria-label={`Key ${rank}`}>{rank}</span> : null}
        <BriefingPhoto photo={photo} code={item.model} onZoom={onZoom ? () => onZoom(item, photo) : undefined} />
      </div>
      <div className={styles.id}>
        <b className={`${styles.model}${item.model ? '' : ' ' + styles.modelPlain}`} title={model}>{model}</b>
        {item.pi ? <span className={styles.pi}><i>PI</i>{item.pi}</span> : null}
      </div>
      <div className={styles.sup}>
        {item.supplier ? <span className={styles.chip}>{item.supplier}</span> : null}
        {item.kindLabel && item.model ? <span className={styles.kind}>{item.kindLabel}</span> : null}
      </div>
      <div className={styles.why}>
        <span className={styles.pill}><span className={cs.dot} /><span className={styles.pillText}>{item.lead}</span></span>
        <span className={styles.line} title={item.line}>{item.line}</span>
      </div>
      <div className={styles.acts}>
        <Acts item={item} handled={handled} canOpen={canOpen} onOpen={onOpen} onDone={onDone} onSnooze={onSnooze} onUndo={onUndo} />
      </div>
    </article>
  );
}

export default ItemRow;
